import { AnyAction } from 'redux';
import * as actionTypes from '../actions/actionTypes';

type QueueDetails = {
  name: string;
  number: number;
  description: string;
};

export type DynamicQueue = {
  accountId: string;
  queueId: number;
  extensionNumber: number;
  priority: number;
  order: number;
  isDynamic: boolean;
  queue: QueueDetails;
  isLogged: boolean;
};

export type DynamicQueueList = DynamicQueue[];

type DynamicQueuesState = {
  data: DynamicQueueList;
  loading: boolean;
};

const initialState: DynamicQueuesState = {
  data: [],
  loading: false,
};

const dynamicQueues = (
  state: DynamicQueuesState = initialState,
  action: AnyAction
): DynamicQueuesState => {
  switch (action.type) {
    case actionTypes.DYNAMIC_QUEUES_STORE:
      return {
        ...state,
        data: action.payload,
      };
    case actionTypes.RESET_DYNAMIC_QUEUES:
      return initialState;
    default:
      return {
        ...state,
      };
  }
};

export default dynamicQueues;
